module.exports = __webpack_public_path__ + "img/pdf.9f72b42f.svg";